import NProgress from 'nprogress';
import services from './services';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import $http from '$http';

//组件
// import baseInfoForm from 'agent-base-info';

export default {
    components: {},
    props: {},
    mixins: [services],
    data() {
        return {
            title: "",
            dialogVisible: false,
            form: {},
            remark: '', //备注
            submitData: this.getSubmitData(), // 提交数据
            isShow: true,
            title2: '金额',
            title3: '修改后余额：',
            isAccountType3: false, //判断是不是转款
            accountTypes: [],
            money1: 0
        }
    },
    computed: {
        changeMoney() {
            if (this.submitData.AccountMoney !== '') {
                if (this.submitData.Operation == 1) {
                    return (this.form.TotalMoney + parseFloat(this.submitData.AccountMoney)).toFixed(2)
                } else if (this.submitData.Operation == 2) {
                    return (this.form.TotalMoney - parseFloat(this.submitData.AccountMoney)).toFixed(2)
                } else if (this.submitData.Operation == 3) {
                    return (this.form.TotalMoney - parseFloat(this.submitData.AccountMoney)).toFixed(2)
                }
            } else {
                return this.form.TotalMoney
            }
        },
        // money1//转款后该账户金额
        // money1() {
        //     if (this.submitData.AccountMoney !== 0) {
        //         if (this.submitData.AccountType == 1) {
        //             return this.form.TotalMoney + parseFloat(this.submitData.AccountMoney)
        //         } else if (this.submitData.AccountType == 2) {
        //             return this.form.TotalMoney - parseFloat(this.submitData.AccountMoney)
        //         }
        //     } else {
        //         return this.form.TotalMoney
        //     }
        // },
        // money2//转款后收款账户金额
        money2() {
            if (this.submitData.AccountMoney !== '') {
                console.log(parseFloat(this.submitData.AccountMoney))
                if (this.submitData.Operation == 3) {
                    return parseFloat(this.money1) + parseFloat(this.submitData.AccountMoney)
                }
            } else {
                return this.money1
            }
        }
    },
    methods: {
        getSubmitData() {
            return cloneDeep({
                "ToAccountType": '',
                "AgentId": 0,
                "Operation": 1,
                "AccountMoney": '',
                "AccountType": '',
                "Remark": ""
            })
        },
        show(options) {
            this.dialogVisible = true;
            this.form = options.data
            console.log(this.form)
            this.submitData.AccountType = this.form.AccountType
            this.submitData.AgentId = options.AgentId
            this.money2 = ''
            this.getAccountTypeData(options.AgentId, this.form.AccountType)
            // 智趣坞已付合同预付款修改
            if (!this.form.AccountTypeName) {
                this.submitData.AccountType = this.form.PaidAccountType
                this.isShow = false;
                this.title = this.form.PaidAccountTypeName + '修改'
                this.form.TotalMoney = this.form.PaidMoney
            } else {
                this.isShow = true;
                this.title = this.form.AccountTypeName + '余额修改'
            }
        },
        changeAccountType(val) {
            for (let i = 0; i < this.accountTypes.length; i++) {
                if (val == this.accountTypes[i].AccountType) {
                    this.money1 = this.accountTypes[i].TotalMoney
                }
            }
        },
        changeOperation(val) {
            if (val == 3) {
                this.isAccountType3 = true
                this.title2 = '转款金额'
                this.title3 = '转款后该账户余额：'
            } else {
                this.isAccountType3 = false
                this.title2 = '金额'
                this.title3 = '修改后余额：'
            }
        },
        submitFn() {
            var flag = util.checkForm({
                ele: this,
                rules: [{
                    name: "金额",
                    value: this.submitData.AccountMoney,
                    required: true,
                    more0: true
                }]
            });
            if (!flag) {
                return;
            }
            //判断输入的金额是否大于当前可用余额
            if (this.submitData.Operation > 1) {
                if (this.submitData.AccountMoney > this.form.TotalMoney) {
                    let errorTip = '当前可用余额为' + this.form.TotalMoney + '；减少金额需小于等于' + this.form.TotalMoney
                    if (this.isAccountType3) {
                        errorTip = '当前可用余额为' + this.form.TotalMoney + '；转款金额需小于等于' + this.form.TotalMoney
                    } else {
                        errorTip = '当前可用余额为' + this.form.TotalMoney + '；减少金额需小于等于' + this.form.TotalMoney
                    }

                    this.$notify({
                        title: '警告',
                        message: errorTip,
                        type: 'warning'
                    });
                    return;
                }
            }

            // 转款判断
            if (this.isAccountType3) {
                if (this.submitData.ToAccountType == '') {
                    this.$notify({
                        title: '警告',
                        message: '请选择收款账户',
                        type: 'warning'
                    });
                    return;
                }
            }

            this.submit(this.submitData)
        },
        closeCallback() {
            this.dialogVisible = false
            this.submitData = this.getSubmitData()
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMAgentAccountManage/components/changeMoney/vm.js